/**
 * UserContext shim. Delegates the /me fetch + JWT-claim hydration + guest
 * 401-recovery to @wg/hooks/user's UserProvider. Same export names as before
 * so existing consumers (Dashboard, useAccount, ProfilePanel, etc.) keep
 * working without touching their imports.
 */
import React from 'react';
import {
  UserProvider as SharedUserProvider,
  useUserContext as useSharedUserContext,
  type User,
  type UserData,
} from '@wg/hooks/user';
import { useAuthContext } from '@wg/hooks/auth';
import { auth, httpClient } from '../client';
import logger from '../utils/logger';

export type { User, UserData };
export { useSharedUserContext as useUserContext };

const Inner = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isGuest } = useAuthContext();
  return (
    <SharedUserProvider
      core={auth}
      httpClient={httpClient}
      logger={logger}
      isAuthenticated={isAuthenticated}
      isGuest={isGuest}
    >
      {children}
    </SharedUserProvider>
  );
};

export const UserProvider = ({ children }: { children: React.ReactNode }) => (
  <Inner>{children}</Inner>
);

export default UserProvider;
